import { useEffect, useState } from "react";
import { openModal } from "lib/actions/modal";
import Modals from "lib/constants/Modals";
import handlePopupFlagError from "lib/errors/handlePopupFlagError";
import { useDispatch } from "store";
import { fetchRoles } from "store/reducers";
import { Pagination } from "types";
import { SecondaryButton } from "components/Buttons";
import StageHeader from "components/StageHeader";
import { RolesTable } from "components/shared";
import PageStage from "components/stages/PageStage";

export const ListRolesPage = () => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState<boolean>(false);
  const [ids, setIds] = useState<number[]>([]);
  const [paging, setPaging] = useState<Pagination>({
    pageStart: 0,
    pageLimit: 20,
    pageCount: 0,
    totalCount: 0,
    nextPageStart: null,
    previousPageStart: null,
  });

  useEffect(() => {
    fetch(paging.pageStart, paging.pageLimit);
  }, [paging.pageStart, paging.pageLimit]);

  const fetch = async (pageStart: number, pageLimit: number) => {
    try {
      setLoading(true);
      const response = await dispatch(fetchRoles({ pageStart, pageLimit })).unwrap();
      setIds(response.results.map(({ id }) => id));
      setPaging(response.paging);
    } catch (err) {
      handlePopupFlagError(err);
    }
    setLoading(false);
  };

  const openInviteModal = () => {
    dispatch(
      openModal(Modals.CREATE_ROLE, {
        onSuccess: () => {
          const { pageLimit } = paging;
          fetch(0, pageLimit);
        },
      }),
    );
  };

  return (
    <PageStage>
      <StageHeader
        title="Roles"
        subtitle="Manage team member access to the management portal by configuring your roles."
        action={
          <SecondaryButton onClick={openInviteModal} icon="/images/icons/plus_1.svg">
            Create role
          </SecondaryButton>
        }
      />
      <RolesTable loading={loading} roleIds={ids} paging={paging} onFetch={fetch} />
    </PageStage>
  );
};
